const calendarDateMoon = (value) => {
  return {
      type: 'CALENDAR_DATE_TABLE_MOON',
      data: value
    };
}
export default calendarDateMoon;
